export var STOCK_SURVILLANCE = "STOCK_SURVILLANCE";
export var STOCK_SURVILLANCE_ERROR = "STOCK_SURVILLANCE_ERROR";
export var STOCK_SURVILLANCE_MSG = "STOCK_SURVILLANCE_MSG";
export var STOCK_SURVILLANCE_CLEAR_MSG = "STOCK_SURVILLANCE_CLEAR_MSG";
export var STOCK_SURVILLANCE_HIDE_ERROR = "STOCK_SURVILLANCE_HIDE_ERROR";
export var STOCK_SURVILLANCE_START_LOADER = "STOCK_SURVILLANCE_START_LOADER";
export var STOCK_SURVILLANCE_STOP_LOADER = "STOCK_SURVILLANCE_STOP_LOADER";
